import {
  BookUser,
  Calculator,
  Calendar,
  CalendarClock,
  FileCheck,
  FileText,
  Merge,
  Pill,
  Search,
  Syringe,
  Users,
  UserSearch,
} from "lucide-react";

import { pathGenerators, ROUTES } from "utils/routes";
import { isTenantTypeAllowed, TENANT_TYPES } from "utils/tenantAccess";

const ICON_SIZE = 20;

export const menuItems = [
  {
    src: Users,
    label: "Consultations",
    url: ROUTES.GLOBAL.REPORTS,
    className: "",
  },
  {
    src: Syringe,
    label: "Immunisations",
    url: pathGenerators.global.reportsType({ reportType: "immunisations" }),
    className: "",
    tenantTypes: [TENANT_TYPES.GP],
  },
  {
    src: Pill,
    label: "Prescriptions",
    url: pathGenerators.global.reportsType({ reportType: "prescriptions" }),
    className: "",
    tenantTypes: [TENANT_TYPES.GP],
  },
  {
    src: Search,
    label: "Referrals",
    url: pathGenerators.global.reportsType({ reportType: "investigations" }),
    className: "",
  },
  {
    src: FileText,
    label: "Letters",
    url: pathGenerators.global.reportsType({ reportType: "letters" }),
    className: "",
  },
  {
    src: Calculator,
    label: "Accounting",
    url: pathGenerators.global.reportsType({ reportType: "accounting" }),
    className: "",
  },
  {
    src: Calendar,
    label: "Appointments",
    url: pathGenerators.global.reportsType({ reportType: "appointments" }),
    className: "",
  },
  {
    src: FileCheck,
    label: "Audit Log",
    url: pathGenerators.global.reportsType({ reportType: "audit-log" }),
    className: "",
  },
  {
    src: Merge,
    label: "Patient Merges",
    url: pathGenerators.global.reportsType({ reportType: "patient-merges" }),
    className: "",
  },
];

// CDM finder / recall / register live under their own sidebar entry ("CDM"),
// not under Reports — so they get their own tab set.
export const cdmMenuItems = [
  {
    src: UserSearch,
    label: "CDM Finder",
    url: pathGenerators.global.cdmFinders({ reportType: "cdm-finder" }),
    className: "",
  },
  {
    src: CalendarClock,
    label: "CDM Recall",
    url: pathGenerators.global.cdmFinders({ reportType: "cdm-recall" }),
    className: "",
  },
  {
    src: BookUser,
    label: "CDM Register",
    url: pathGenerators.global.cdmFinders({ reportType: "cdm-register" }),
    className: "",
    tenantTypes: [TENANT_TYPES.GP],
  },
];

export const CDM_REPORT_TYPES = ["cdm-finder", "cdm-recall", "cdm-register"];

export const isCdmReportType = (reportType) =>
  CDM_REPORT_TYPES.includes(reportType);

const toTabOptions = (items, tenantType) =>
  items
    .filter((item) => isTenantTypeAllowed(item.tenantTypes, tenantType))
    .map((item) => {
      const Icon = item.src;
      return {
        value: item.url,
        label: item.label,
        icon: <Icon size={ICON_SIZE} strokeWidth={2} aria-hidden />,
      };
    });

// The CDM report types show only the 3 CDM tabs; everything else shows the
// standard Reports tabs.
export const getTabOptions = (reportType, tenantType) =>
  toTabOptions(
    isCdmReportType(reportType) ? cdmMenuItems : menuItems,
    tenantType
  );
